import { useTranslation } from '@/i18n';
import { ButtonGroup, ButtonV2 } from '@moneyforward/ap-frontend-components';
import cx from 'classnames';
import React from 'react';
import styles from '../index.module.scss';

interface InstructionFooterProps {
  onCancel: () => void;
  onDownload: () => void;
  isDownloading?: boolean;
  isFormValid?: boolean;
}

export const InstructionFooter: React.FC<InstructionFooterProps> = ({
  onCancel,
  onDownload,
  isDownloading = false,
  isFormValid = true,
}) => {
  const { t } = useTranslation();
  return (
    <div className={cx(styles.footer_container)}>
      <ButtonGroup direction='horizontal'>
        <ButtonV2 color='primary' isSecondary onClick={onCancel} size='sm'>
          {t('export_instruction_pdf_dialog_cancel')}
        </ButtonV2>
        <ButtonV2
          color='primary'
          onClick={onDownload}
          size='sm'
          isLoading={isDownloading}
          isDisabled={isDownloading || !isFormValid}
        >
          {t('export_instruction_pdf_dialog_download')}
        </ButtonV2>
      </ButtonGroup>
    </div>
  );
};
